/* eslint-disable */
import type { SVGProps } from 'react';
import { memo } from 'react';

const MV = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1000"
    height="600"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1000 600"
    {...props}
  >
    <path
      fill="#fff"
      d="M0 0H1000V600H0"
    />
    <path
      fill="#2b58a3"
      d="M0 0H1000V160H0"
    />
    <path
      fill="#f9f400"
      d="M0 280H1000v40H0"
    />
    <path
      fill="#de0029"
      d="M0 440H1000V600H0"
    />
  </svg>
);
export default memo(MV);
